'use client'

import { useTranslations } from 'next-intl'
import type { PropsWithChildren } from 'react'

import { usePathname, useRouter } from '@/shared/i18n'
import { InnerLayout, OuterLayout, SegmentedControl } from '@/shared/ui'

type Props = {
  title: string
  userType: 'guest' | 'host'
  type: 'event' | 'partnership' | 'article'
  className?: string
}

export const CampaignLayout = ({
  title,
  userType,
  type,
  children,
  className,
}: PropsWithChildren<Props>) => {
  const router = useRouter()
  const pathname = usePathname()

  const t = useTranslations('events_partnerships')

  const handleTypeChange = (value: string) => {
    if (pathname?.includes(value)) {
      return
    }

    router.push(`/${userType}/campaign/${value}`)
  }

  return (
    <OuterLayout className={className}>
      <InnerLayout className="mt-15 mb-10 space-y-10">
        <h2 className="typo-title2 font-semibold text-black">{title}</h2>
        {type !== 'article' && (
          <SegmentedControl.Root
            type="single"
            variant="padded"
            shape="pill"
            size="medium"
            width="full"
            value={type}
            onValueChange={handleTypeChange}
          >
            <SegmentedControl.Item value="event" id="event">
              {t('tab.event')}
            </SegmentedControl.Item>
            <SegmentedControl.Item value="partnership" id="partnership">
              {t('tab.partnership')}
            </SegmentedControl.Item>
          </SegmentedControl.Root>
        )}
        {children}
      </InnerLayout>
    </OuterLayout>
  )
}
